module.exports = __webpack_public_path__ + "static/img/bni.bf4e646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bni.png
// module id = dujh
// module chunks = 1